import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router"
import { getId, getToken, usePermissions } from "../../user/User"
import { toast } from "react-toastify"
import { useEffect } from "react"
import { useSector } from "../../sector/Sector"
import axios from 'axios'

const SectorDelete = () => {
    const navigate = useNavigate()

    let { id } = useParams()
    let { name } = useSector(id)

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.sector === undefined) {
            return
        }
        if(!permissions.sector) {
            toast.error("You don't have permission to delete sectors!")
            navigate("/")
        } else {
            if (confirm('Do you really want to delete this sector?')) {
                axios.delete(process.env.REACT_APP_API_URL + "/api/sectors/" + id, { headers: {
                    "Authorization": "Bearer " + getToken()
                }}).then(_ => {
                    toast.success("Deleted sector " + name + " #" + id + ".")
                    navigate("/sector")
                }).catch(error => {
                    if (error.response) {
                        var statusCode = error.response.status
                        if(statusCode === 400) {
                            navigate("/sector")
                            toast.error("Invalid request.")
                            return
                        } else if(statusCode === 404) {
                            navigate("/sector")
                            toast.error("Unable to find sector #" + id + ".")
                            return
                        } else if(statusCode === 409) {
                            navigate("/sector")
                            toast.error("The sector #" + id + " is used in the client(s): " + error.response.data.clients.map(String).join(", "))
                            return
                        }
                    }
                    navigate("/sector")
                    toast.error("Internal error.")
                })
            } else {
                navigate("/sector")
            }
        }
    }, [permissions])

    return (
        <>
            <p>Deleting sector...</p>
        </>
    )
}

export default SectorDelete